import { Link } from "react-router";

import { cn } from "@/lib/utils";

import { HW_BUTTON_BASE, HW_BUTTON_PRIMARY } from "./diagnostic/components/hw-button";

export function NotFoundPage() {
  return (
    <div className="bg-hw-paper text-hw-ink flex min-h-screen flex-col items-center justify-center px-6 [color-scheme:light]">
      <p className="hw-mono">Page not found</p>
      <h1 className="mt-4 text-6xl leading-[0.9] font-light tracking-[-0.065em]">404</h1>
      <p className="text-hw-soft hw-body mt-4 max-w-sm text-center">
        That page does not exist, or it has moved.
      </p>
      <Link to="/" className={cn(HW_BUTTON_BASE, HW_BUTTON_PRIMARY, "mt-8")}>
        Back to the interview
      </Link>
    </div>
  );
}
